import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Icon,
} from 'advenio-components'
import { formatPrice } from '../../../utils/Utils';

const Container = styled.div`
  width: 100%;
  background: rgba(226,232,236, .3);
`
const Table = styled.table`
  height: 100%;
  width: 100%;
  border-spacing:0;
  border-collapse: collapse;
`
const TableRow = styled.tr`
  display: flex;
  width: 100%;
`
const TableHeaderLarge = styled.th`
  display: flex;
  flex: 8;
  padding: 4px;
  font-size: 14px;
`
const TableHeaderSmall = styled.th`
  display: flex;
  flex: 1;
  justify-content: ${props => props.center ? 'center' : 'flex-start'};
  width: 120px;
  padding: 4px;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-basis: auto;
`
const TableCellLarge = styled.td`
  display: flex;
  flex: 8;
  padding: 4px;
  font-size: 14px;
  background: white;
`
const TableCellSmall = styled.td`
  display: flex;
  flex: 1;
  justify-content: ${props => props.center ? 'center' : 'flex-start'};
  width: 120px;
  padding: 4px;
  font-size: 14px;
  background: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-basis: auto;
`
const SpecialTableRow = styled.tr`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`
const CellTextPosition = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
}
const SpecialTableCell = styled.td`
  flex: 1;
  display: flex;
  justify-content: ${props => CellTextPosition[props.position]};
  width: 120px;
  padding-right: 8px;
  background: rgba(226,232,236, .6);
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-basis: auto;
`
const EmptyState = styled.td`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  color: rgba(0,0,0, .5);
`

class ChargesTable extends Component {
  calculateSubtotal = () => this.props.charges.reduce((sum, charge) => sum + charge.unit_price, 0)

  calculateTax = () => this.props.charges.reduce((sum, charge) => sum + charge.iva_amount, 0)

  calculateTotal = () => this.props.charges.reduce((sum, charge) => sum + charge.total, 0)

  renderCharges = () => {
    const {
      charges,
      removeCharge,
    } = this.props

    if (charges.length <= 0) {
      return <TableRow><EmptyState colspan="4"> Sin Cargos</EmptyState></TableRow>
    }

    return (
      charges.map(charge => (
        <TableRow key={charge.id}>
          <TableCellLarge>
            {charge.concept}{charge.is_direct && ' (D)'}
            <Icon type="remove" onClick={() => removeCharge(charge.id)} color="gray" />
          </TableCellLarge>
          <TableCellSmall center>
            {charge.quantity}
          </TableCellSmall>
          <TableCellSmall center>
            ${charge.total_price}
          </TableCellSmall>
          <TableCellSmall >
            ${charge.total}
          </TableCellSmall>
        </TableRow>
      ))
    )
  }

  render() {
    const {
      currency,
    } = this.props

    return (
      <Container>
        <Table>
          <thead>
            <TableRow>
              <TableHeaderLarge>
                Concepto
              </TableHeaderLarge>
              <TableHeaderSmall center>
                Cantidad
              </TableHeaderSmall>
              <TableHeaderSmall center>
                Precio Unitario
              </TableHeaderSmall>
              <TableHeaderSmall >
                Monto
              </TableHeaderSmall>
            </TableRow>
          </thead>
          <tbody>
            {this.renderCharges()}
            <SpecialTableRow>
              <TableHeaderSmall />
              <TableHeaderLarge />
              <TableHeaderSmall />
              <SpecialTableCell position="right">
                SubTotal
              </SpecialTableCell>
              <SpecialTableCell position="left">
                {formatPrice(this.calculateSubtotal(), currency)}
              </SpecialTableCell>
            </SpecialTableRow>
            <SpecialTableRow>
              <TableHeaderSmall />
              <TableHeaderLarge />
              <TableHeaderSmall />
              <SpecialTableCell position="right">
                IVA
              </SpecialTableCell>
              <SpecialTableCell position="left">
                {formatPrice(this.calculateTax(), currency)}
              </SpecialTableCell>
            </SpecialTableRow>
            <SpecialTableRow>
              <TableHeaderSmall />
              <TableHeaderLarge />
              <TableHeaderSmall />
              <SpecialTableCell position="right">
                Total
              </SpecialTableCell>
              <SpecialTableCell position="left">
                {formatPrice(this.calculateTotal(), currency)}
              </SpecialTableCell>
            </SpecialTableRow>
          </tbody>
        </Table>
      </Container>
    )
  }
}

ChargesTable.propTypes = {
  /** The listing of charges to be displayed in the table */
  charges: PropTypes.array.isRequired,
  /** The currency in which to display the charge prices */
  currency: PropTypes.object.isRequired,

  /** Callback function to be fired when removing a charge from the table */
  removeCharge: PropTypes.func.isRequired,
}

export default ChargesTable



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/ChargesTable.jsx